module.exports = __webpack_public_path__ + "static/media/talk01_small@3x.34b8fa1b.jpg";